import React, {useCallback} from 'react';
import {GatewayGetSchema} from '../../../../api/DBSchema/Gateway';
import LockToPlanContainer from '../../../../components/Editor/LockToPlanContainer';
import BaseRemoteAccess from '../../AbstractObjects/GatewayPlan/InnerPages/BaseRemoteAccess';
import {useTranslation} from 'react-i18next';
import Indentation from '../../../../components/Simple/Indentation';
import SMCLink from '../../../../components/Simple/SMCLink';
import {doSeamlessLogin} from '../../../../utils/utils';
import SMCIcon from '../../../../components/Simple/SMCIcon';
import {remoteAccessIcon} from "../../../../assets/images/headerIcons";

const pageSchema = GatewayGetSchema.pages.remoteAccess;
const pageId = pageSchema.pageId;

function GatewayRemoteAccess({
    gatewayObject,
    planObject,
    setGatewayData
}) {
    const { t } = useTranslation();

    const gatewayPage = gatewayObject[pageId];
    const planPage = planObject[pageId];
    const lockedToPlan = gatewayPage[pageSchema.lockedToPlan];

    let currentPageData;
    if (lockedToPlan) {
        currentPageData = planPage;
    } else {
        currentPageData = gatewayPage;
    }

    const onToggleLockedToPlan = useCallback(locked => {
        // If unlocked page from plan, set all gateway fields to plan's fields
        if (!locked) {
            setGatewayData(pageId, planPage);
        }
        setGatewayData([pageId, pageSchema.lockedToPlan], locked);

    }, [setGatewayData, planPage]);


    return (
        <>
        <LockToPlanContainer
            locked={lockedToPlan}
            onToggleLocked={onToggleLockedToPlan}
            labelText={t('SMP.GATEWAYS.INNER_MENU.REMOTE_ACCESS')}
            icon={remoteAccessIcon}
        >
            <BaseRemoteAccess
                pageData={currentPageData}
                setObjectData={setGatewayData}
                pageDisabled={lockedToPlan}
            />
        </LockToPlanContainer>
        <Indentation>
            <SMCLink onClick={() => doSeamlessLogin(gatewayObject.id, null, 'app.VPNRemoteAccess')}><SMCIcon style={{ verticalAlign: 'middle' }} icon="seamlessLogin" /> {t('SMP.ACCESS_GATEWAY.REMOTE_ACCESS')}</SMCLink>
        </Indentation>
        </>
    );
}

export default GatewayRemoteAccess;